import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Link as RRLink } from 'react-router-dom';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';

const styles = css`
  padding: 40px 0 0;
  background-color: #FFFFFF;
  position: relative;
  z-index: 1;
  @media(min-width: 992px) {
    padding: 80px 0 0;
  }
  .LinksWidget_list {
    width: 100%;
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    position: relative;
    @media(min-width: 992px) {
      flex-wrap: nowrap;
    }
  }
  .LinksWidget_item {
    width: 100%;
    height: 230px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin: 0 0 1px;
    transition: all .3s ease-out;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    @media(min-width: 992px) {
      margin: 1px;
      height: 392px;
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      background-color: rgba(26, 26, 26, 0.25);
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      transition: all .5s ease-out;
    }
    &:hover::after {
      background-color: rgba(26, 26, 26, 0.65);
    }
    &:hover {
      .LinksWidget_content {
        font-size: 17px;
        @media(min-width: 992px) {
          font-size: 19px;
        }
      }
    }
  }
  .LinksWidget_content {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;
    padding: 0 20px;
    font-weight: 900;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 2.25px;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    transition: all .5s ease-out;
    @media(min-width: 992px) {
      padding: 0 50px;
      font-size: 17px;
      letter-spacing: 2.55px;
    }
  }
`;

function LinksWidget({ widget }) {
  return (
    <div className={styles}>
      <div className="d-flex justify-content-center m-auto LinksWidget_list">
        {
          get(widget, 'links').slice(0, 3).map(item => (
            <RRLink to={get(item, 'route')} style={{ backgroundImage: `url(${buildThumbnailUrl(get(item, 'image.contentUrl'), { width: 400, height: 400, preserve: true })})` }} className="LinksWidget_item col-sm-12 col-md-6 col-lg-4" key={get(item, '_id')}>
              <hgroup className="LinksWidget_content">
                <span className="LinksWidget_title" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'title'))} />
              </hgroup>
            </RRLink>
          ))
        }
      </div>
    </div>
  );
}

LinksWidget.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default withData({
  widget: 'links_widget',
})(LinksWidget);



// WEBPACK FOOTER //
// ./src/components/PageWrapper/LinksWidget.js